import styled from 'styled-components'

import { COLOURS } from 'resources'
import { clockIcon } from 'resources/images'

export const SpinnerContainer = styled.span`
  font-size: 16px;
  margin-left: 5px;
`

export const Card = styled.div`
  background-color: ${COLOURS.black};
  border-radius: 4px;
  padding: 30px 20px 20px;
  margin-bottom: 20px;
`

export const CardContentContainer = styled.div`
  width: 100%;
  align-items: flex-start;
`

export const TitleContainer = styled.div`
  display: inline-block;
  align-items: center;
  margin-bottom: 5px;
`

export const CardTitle = styled.span`
  color: ${COLOURS.neutralWhite};
  font-family: Druk, sans-serif;
  font-size: 30px;
  line-height: 30px;
  margin-bottom: 5px;
  white-space: pre-wrap;
`

export const StatusText = styled(CardTitle)`
  color: ${COLOURS.secondaryPurple2};
`

export const CardSubTextContainer = styled.div`
  display: flex;
  align-items: center;
`

export const WhiteClockIcon = styled.img.attrs({
  src: clockIcon,
  alt: 'Clock',
})`
  width: 16px;
  height: 16px;
  margin-right: 5px;
`

export const CardSubText = styled.span`
  margin: 0;
  color: ${COLOURS.neutralWhite};
  font-family: 'EBGaramond', serif;
  font-size: 16px;
  line-height: 16px;
`

export const PurpleCardSubText = styled(CardSubText)`
  color: ${COLOURS.secondaryPurple2};
`

export const Line = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${COLOURS.neutralGrey5};
  margin: 10px 0;
`

export const LinkContainer = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
`

export const CardSubTextArrowIcon = styled.img`
  margin-left: 20px;
`
